import { LIST_SEPARATOR } from '../configs'

export const parseClipboardTokens = (text: string): string[] =>
  text
    .split(LIST_SEPARATOR)
    .map((token) => token.trim())
    .filter(Boolean)
